import z from "zod";
import {
  COMPANY_DIGITAL_CERTIFICATE_DOCUMENT_DIGITS,
  COMPANY_DIGITAL_CERTIFICATE_DOCUMENT_KIND,
  COMPANY_DIGITAL_CERTIFICATE_DOCUMENT_MAX_LENGTH,
  getCompanyDigitalCertificateDocumentDigits,
  getCompanyDigitalCertificateDocumentKind,
} from "../digitalCertificateDocument";

const translationPath = "page.register.digital_certificates.errors.";

const typeDocumentSchema = z.object(
  {
    id: z.string(),
    name: z.string().optional().nullable(),
    identifier: z.string().optional().nullable(),
    code: z.string().optional().nullable(),
    value: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "type_document" },
);

export const digitalCertificateSchema = z.object({
  id: z.string().optional(),
  enable: z.boolean(),
  useCertillionLocalAgent: z.boolean(),
  name: z.string().min(1, { message: translationPath + "name" }),
  typeDocument: typeDocumentSchema
    .nullable()
    .refine(Boolean, { message: translationPath + "type_document" }),
  document: z
    .string()
    .min(1, { message: translationPath + "document" })
    .max(COMPANY_DIGITAL_CERTIFICATE_DOCUMENT_MAX_LENGTH.CNPJ, {
      message: translationPath + "document_max_length",
    }),
}).superRefine((value, ctx) => {
  const documentKind = getCompanyDigitalCertificateDocumentKind({
    typeDocument: value.typeDocument,
  });
  const documentDigits = getCompanyDigitalCertificateDocumentDigits(
    value.document,
  );

  if (!documentDigits.length) return;

  if (
    documentKind === COMPANY_DIGITAL_CERTIFICATE_DOCUMENT_KIND.CPF &&
    documentDigits.length !== COMPANY_DIGITAL_CERTIFICATE_DOCUMENT_DIGITS.CPF
  ) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["document"],
      message: translationPath + "document_cpf_length",
    });
  }

  if (
    documentKind === COMPANY_DIGITAL_CERTIFICATE_DOCUMENT_KIND.CNPJ &&
    documentDigits.length !== COMPANY_DIGITAL_CERTIFICATE_DOCUMENT_DIGITS.CNPJ
  ) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["document"],
      message: translationPath + "document_cnpj_length",
    });
  }
});

export type TDigitalCertificateForm = z.infer<typeof digitalCertificateSchema>;
